import {
  DataTypeStoreExtended,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
} from '@app-store'
import { createContext, ReactNode, useState, useMemo } from 'react'
// import { WEBSOCKET_ACTIONS } from '../utils/constants'
import { v4 as uuidV4 } from 'uuid'

interface WebSocketContextProps {
  wsHelper: WebSocket | null
  messages: DataTypeStoreExtended | undefined
  sendMessage?: (message: string) => void
  setMessages?: React.Dispatch<
    React.SetStateAction<DataTypeStoreExtended | undefined>
  >
  connectionId?: string
  uid?: string
  uids?: { [key: string]: string }
  getUid?: (entity: string) => string
}
export const WebSocketContext = createContext<WebSocketContextProps>({
  wsHelper: null,
  messages: undefined,
  sendMessage: undefined,
})

export const WebSocketProvider = ({ children }: { children: ReactNode }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [wsHelper] = useState<WebSocket | null>(null)
  const [messages, setMessages] = useState<DataTypeStoreExtended>()
  // const [connectionId, setConnectionId] = useState<string>()
  // const [uid, setUid] = useState<string>()
  const [uids, setUids] = useState<{ [key: string]: string }>()
  const getUid = (entity: string) => {
    if (uids?.[entity]) return uids[entity]
    const uid = uuidV4()
    setUids({ ...uids, [entity]: uid })
    return uid
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const initializeWebsocket = (url: string) => {
  //   const socket = new WebSocket(url)

  //   socket.onopen = () => {
  //     socket.send(
  //       JSON.stringify({
  //         requestContext: { routeKey: WEBSOCKET_ACTIONS.CONNECTION_DATA },
  //       })
  //     )
  //     console.log('WebSocket connection opened')
  //   }

  //   socket.onclose = () => {
  //     console.log('WebSocket connection closed')
  //   }

  //   socket.onerror = (error) => {
  //     console.error('WebSocket error: ', error)
  //   }
  //   socket.onmessage = (event) => {
  //     const message = JSON.parse(event.data)
  //     if (message?.routeKey === WEBSOCKET_ACTIONS.CONNECTION_DATA) {
  //       setConnectionId(message?.connectionId)
  //       setUid(message?.uid)
  //     } else setMessages(message)
  //   }

  //   return socket
  // }
  const sendMessage = (message: string) => {
    if (wsHelper?.readyState === WebSocket.OPEN) {
      wsHelper.send(message)
    }
  }

  // TODO: Disable websocket for now as we are not using it right now.

  // useEffect(() => {
  //   const helper = initializeWebsocket(WEBSOCKET_URL)
  //   setWsHelper(helper)
  //   return () => {
  //     wsHelper?.send(
  //       JSON.stringify({
  //         requestContext: {
  //           routeKey: WEBSOCKET_ACTIONS.DISCONNECT,
  //           connectionId,
  //           uid,
  //         },
  //       })
  //     )
  //     helper.close()
  //   }
  // }, [])

  const contextValue = useMemo(
    () => ({
      wsHelper,
      messages,
      sendMessage,
      setMessages,
      // connectionId,
      // uid,
      uids,
      getUid,
    }),
    [
      wsHelper,
      messages,
      sendMessage,
      setMessages,
      // connectionId,
      // uid,
      uids,
      getUid,
    ]
  )

  return (
    <WebSocketContext.Provider value={contextValue}>
      {children}
    </WebSocketContext.Provider>
  )
}
